var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 748,
    viewBox: "0 0 747 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0002 747.613C21.2655 747.613 0.333496 726.707 0.333496 700.947V47.6134C0.333496 21.8534 21.2655 0.946777 47.0002 0.946777H350.334C363.235 0.946777 373.667 11.379 373.667 24.2801V70.9468C373.667 83.8478 363.235 94.2801 350.334 94.2801H93.6668V654.28H653.667V397.613C653.667 384.712 664.099 374.28 677 374.28H723.667C736.568 374.28 747 384.712 747 397.613V700.947C747 726.707 726.068 747.613 700.334 747.613H47.0002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.667 1.00005H490.333C480.906 1.00005 472.364 6.64591 468.771 15.396C465.156 24.0991 467.161 34.1307 473.833 40.828L557.505 124.5L324.172 357.833C315.047 366.958 315.047 381.703 324.172 390.828L357.167 423.823C366.338 432.948 381.084 432.948 390.208 423.823L623.515 190.489L707.165 274.161C711.618 278.62 717.592 281 723.66 281C726.67 281 729.702 280.417 732.597 279.182C741.321 275.609 746.993 267.047 746.993 257.666V24.3328C746.993 11.385 736.561 0.999512 723.66 0.999512L723.667 1.00005Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747,
    height: 748,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.d20a2e69f61514753533e1c4259303fd.svg";
export { ForwardRef as ReactComponent };